import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";

// core styles
import "./scss/volt.scss";
import "../src/components/css/theme.css";
import "../src/components/css/main.css";
import "../src/components/css/dashboard.css";
import "../src/components/css/network.css";

// vendor styles
import "react-datetime/css/react-datetime.css";
import "react-toastify/dist/ReactToastify.css";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";

const container = document.getElementById("root");
const root = createRoot(container);

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 20, color: "crimson" }}>
          App crashed: {String(this.state.error?.message || this.state.error)}
        </div>
      );
    }

    return this.props.children;
  }
}

root.render(
  <RootErrorBoundary>
    <BrowserRouter>
      <ScrollToTop />
      <HomePage />
    </BrowserRouter>
  </RootErrorBoundary>
);
